import { render, staticRenderFns } from "./ModalCloseButton.vue?vue&type=template&id=49cd54f4"
import script from "./ModalCloseButton.vue?vue&type=script&lang=js"
export * from "./ModalCloseButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports